"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const PageHeader_1 = __importDefault(require("./PageHeader"));
const AppBar_1 = __importDefault(require("@mui/material/AppBar"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Tab_1 = __importDefault(require("@mui/material/Tab"));
const Tabs_1 = __importDefault(require("@mui/material/Tabs"));
const userReportApi_1 = require("../services/userReportApi");
const react_1 = require("react");
const shared_1 = require("../shared");
const ResultGrid_1 = __importDefault(require("./ResultGrid"));
const services_1 = require("../services");
const styles_1 = require("@mui/material/styles");
const DashboardReport_1 = __importDefault(require("./DashboardReport"));
const StyledTab = (0, styles_1.styled)(Tab_1.default)({
    '&.MuiTab-root': {
        textDecoration: 'none',
        textTransform: 'none',
    },
    '&.Mui-selected': {},
});
const TabPanel = (props) => {
    const { children, value, index } = props, other = __rest(props, ["children", "value", "index"]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ role: 'tabpanel', hidden: value !== index, id: `full-width-tabpanel-${index}`, "aria-labelledby": `full-width-tab-${index}` }, other, { children: value === index && (0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: { p: 1 } }, { children: children })) })));
};
const tabProps = (index) => {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
};
const UserReport = () => {
    var _a, _b, _c, _d, _e, _f, _g;
    const params = new URLSearchParams(window.location.search);
    const userId = params.get('userId');
    const quizId = params.get('quizId');
    const isBlueBookData = params.get('isBlueBookData');
    const theme = (0, styles_1.useTheme)();
    const [value, setValue] = React.useState(0);
    const [header, setHeader] = React.useState('');
    const [user, setUser] = (0, react_1.useState)({});
    const [completeDate, setCompleteDate] = (0, react_1.useState)('');
    const [category, setTestCategory] = (0, react_1.useState)('');
    const [testName, setTestName] = (0, react_1.useState)('');
    const [testType, setTestType] = (0, react_1.useState)([]);
    const [quiz, setQuiz] = (0, react_1.useState)([]);
    const [bluebookSections, setBluebookSections] = (0, react_1.useState)([
        { id: 1, section: 'Reading and Writing' },
        { id: 2, section: 'Reading and Writing 2 Easy' },
        { id: 3, section: 'Math' },
        { id: 4, section: 'Math 2 Easy' },
    ]);
    const { data: userReport, isLoading, refetch, } = (0, userReportApi_1.useUserReportQuery)(quizId, {
        refetchOnFocus: true,
    });
    const { data: testTypeData } = (0, services_1.useTestTypeQuery)({});
    const [dashboardView, setDashboardView] = (0, react_1.useState)(true);
    const initData = async () => {
        setUser(await (0, shared_1.getUserById)(userId));
        setQuiz(await (0, shared_1.getStrapiData)(`diagnostics?&populate=*&pagination[pageSize]=100`));
    };
    const [filterValue, setFilterValue] = (0, react_1.useState)('');
    const [flaggedQns, setFlaggedQns] = React.useState([
        {
            id: 0,
            type: '',
        },
    ]);
    console.log('dashboardView', dashboardView);
    console.log('isBlueBookData', isBlueBookData);
    (0, react_1.useEffect)(() => {
        initData();
        refetch();
    }, []);
    console.log('userReport nre 1', userReport);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (userReport) {
            // console.log('userReport', userReport);
        }
        if (testTypeData) {
            const test = ((_a = testTypeData === null || testTypeData === void 0 ? void 0 : testTypeData.testTypes) === null || _a === void 0 ? void 0 : _a.data) || [];
            setTestType(test);
        }
        if (userReport && ((_b = userReport === null || userReport === void 0 ? void 0 : userReport.diagnostic) === null || _b === void 0 ? void 0 : _b.isBlueBookData)) {
            setHeader(`${((_c = userReport === null || userReport === void 0 ? void 0 : userReport.testinfo) === null || _c === void 0 ? void 0 : _c.testName) || 'N/A'} - ${(_d = userReport === null || userReport === void 0 ? void 0 : userReport.testinfo) === null || _d === void 0 ? void 0 : _d.date}`);
            setTestName(((_e = userReport === null || userReport === void 0 ? void 0 : userReport.testinfo) === null || _e === void 0 ? void 0 : _e.testName) || 'N/A');
            setCompleteDate(formatDate(userReport === null || userReport === void 0 ? void 0 : userReport.completeDate, 'custom'));
            if ((_f = userReport === null || userReport === void 0 ? void 0 : userReport.diagnostic) === null || _f === void 0 ? void 0 : _f.bluebookData) {
                const sections = userReport.diagnostic.bluebookData.reduce((acc, item) => {
                    const section = item.questionData.section;
                    if (!acc.find((entry) => entry.section === section)) {
                        acc.push({ id: acc.length + 1, section });
                    }
                    return acc;
                }, []);
                console.log('sections', sections);
                setBluebookSections(sections);
            }
        }
        if (userReport && testTypeData) {
            const testType = ((_g = testTypeData === null || testTypeData === void 0 ? void 0 : testTypeData.testTypes) === null || _g === void 0 ? void 0 : _g.data) || [];
            const test = testType === null || testType === void 0 ? void 0 : testType.find((x) => { var _a; return x.id === `${(_a = userReport === null || userReport === void 0 ? void 0 : userReport.diagnostic) === null || _a === void 0 ? void 0 : _a.testtype}`; });
            setHeader(`${((_h = test === null || test === void 0 ? void 0 : test.attributes) === null || _h === void 0 ? void 0 : _h.Name) || 'N/A'} - ${formatDate(userReport === null || userReport === void 0 ? void 0 : userReport.completeDate)}`);
            setTestName(((_j = test === null || test === void 0 ? void 0 : test.attributes) === null || _j === void 0 ? void 0 : _j.Name) || 'N/A');
            const firstScoreKey = ((_k = userReport === null || userReport === void 0 ? void 0 : userReport.diagnostic) === null || _k === void 0 ? void 0 : _k.score) ? Object.keys(userReport.diagnostic.score)[0] : undefined;
            getQuizCategory(firstScoreKey);
            setCompleteDate(formatDate(userReport === null || userReport === void 0 ? void 0 : userReport.completeDate, 'custom'));
        }
    }, [userReport, testTypeData]);
    const handleChange = (event, newValue) => {
        console.log('newValue', newValue);
        setValue(newValue);
    };
    console.log('userReport', userReport);
    const getQuizCategory = (id) => {
        var _a;
        const test = quiz === null || quiz === void 0 ? void 0 : quiz.find((x) => `${x.id}` === `${id}`);
        setTestCategory((_a = test === null || test === void 0 ? void 0 : test.attributes) === null || _a === void 0 ? void 0 : _a.Category);
    };
    const getQuiz = (id) => {
        var _a;
        const test = quiz === null || quiz === void 0 ? void 0 : quiz.find((x) => `${x.id}` === `${id}`);
        return ((_a = test === null || test === void 0 ? void 0 : test.attributes) === null || _a === void 0 ? void 0 : _a.Name) || '';
    };
    const formatDate = (date, format = 'default') => {
        try {
            let currenDate = new Date(date);
            if (!date)
                currenDate = new Date();
            const options = format === 'custom'
                ? {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                }
                : {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                };
            const formattedDate = currenDate.toLocaleDateString(undefined, options).replace(',', '');
            return formattedDate;
        }
        catch (error) {
            console.error('Error formatting date:', error);
        }
        return '';
    };
    const handleDetailView = () => {
        if (dashboardView) {
            setDashboardView(false);
        }
        else {
            setDashboardView(true);
            handleFilter('', '', '', 'reset');
        }
    };
    const handleFilter = (field, operator, value, mode) => {
        if (dashboardView) {
            setDashboardView(false);
        }
        else {
            setDashboardView(true);
        }
        if (field && operator && value) {
            let result = field.concat('~', operator, '~', value);
            setFilterValue(result);
        }
        if (mode === 'reset') {
            setFilterValue('');
        }
    };
    if (isLoading)
        return (0, jsx_runtime_1.jsx)("div", { children: "Loading..." });
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ style: { width: '100%', padding: '20px 30px' } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'user-report' }, { children: [(0, jsx_runtime_1.jsx)(PageHeader_1.default, { userId: userId, user: user, header: header, data: userReport, quiz: quiz, dashboardView: dashboardView, handleDetailView: handleDetailView }), !dashboardView ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: userReport && ((_a = Object.keys(userReport)) === null || _a === void 0 ? void 0 : _a.length) > 0 ? ((0, jsx_runtime_1.jsxs)(Box_1.default, Object.assign({ sx: { bgcolor: 'background.paper', width: '100%' } }, { children: [(0, jsx_runtime_1.jsx)(AppBar_1.default, Object.assign({ position: 'static' }, { children: (0, jsx_runtime_1.jsxs)(Tabs_1.default, Object.assign({ value: value, onChange: handleChange, textColor: 'inherit', variant: 'fullWidth', "aria-label": 'full width tabs example', TabIndicatorProps: {
                                            style: {
                                                backgroundColor: '#000',
                                            },
                                        }, sx: {
                                            color: '#000',
                                            backgroundColor: '#FFF',
                                        } }, { children: [(0, jsx_runtime_1.jsx)(StyledTab, Object.assign({ label: 'All Questions' }, tabProps(0))), ((_b = userReport === null || userReport === void 0 ? void 0 : userReport.diagnostic) === null || _b === void 0 ? void 0 : _b.isBlueBookData)
                                                ? (_c = (bluebookSections || [])) === null || _c === void 0 ? void 0 : _c.map(({ id, section }) => ((0, jsx_runtime_1.jsx)(StyledTab, Object.assign({ label: section || '' }, tabProps(id)), id)))
                                                : Object.keys(((_d = userReport === null || userReport === void 0 ? void 0 : userReport.diagnostic) === null || _d === void 0 ? void 0 : _d.questions) || {}).map((tabId) => ((0, jsx_runtime_1.jsx)(StyledTab, Object.assign({ label: getQuiz(tabId) || tabId }, tabProps(tabId)), tabId)))] })) })), (0, jsx_runtime_1.jsx)(TabPanel, Object.assign({ value: value, index: 0, dir: theme.direction }, { children: (0, jsx_runtime_1.jsx)(ResultGrid_1.default, { id: 0, data: userReport, quiz: quiz, header: header, userName: user === null || user === void 0 ? void 0 : user.name, testName: `${testName || ''}-${category || ''}`, completeDate: completeDate, filterValue: filterValue, flaggedQns: flaggedQns, setFlaggedQns: setFlaggedQns, refetch: refetch }) })), ((_e = userReport === null || userReport === void 0 ? void 0 : userReport.diagnostic) === null || _e === void 0 ? void 0 : _e.isBlueBookData)
                                    ? (_f = (bluebookSections || [])) === null || _f === void 0 ? void 0 : _f.map(({ id, section }, index) => ((0, jsx_runtime_1.jsx)(TabPanel, Object.assign({ value: value, index: index + 1, dir: theme.direction }, { children: (0, jsx_runtime_1.jsx)(ResultGrid_1.default, { id: id, data: userReport, quiz: quiz, header: header, userName: user === null || user === void 0 ? void 0 : user.name, testName: `${testName || ''}-${category || ''}`, completeDate: completeDate, filterValue: filterValue, flaggedQns: flaggedQns, setFlaggedQns: setFlaggedQns, refetch: refetch, bluebookSections: bluebookSections }) }), id)))
                                    : Object.keys(((_g = userReport === null || userReport === void 0 ? void 0 : userReport.diagnostic) === null || _g === void 0 ? void 0 : _g.questions) || {}).map((tabId, idx) => ((0, jsx_runtime_1.jsx)(TabPanel, Object.assign({ value: value, index: idx + 1, dir: theme.direction }, { children: (0, jsx_runtime_1.jsx)(ResultGrid_1.default, { id: parseInt(tabId, 10), data: userReport, quiz: quiz, header: header, userName: user === null || user === void 0 ? void 0 : user.name, testName: `${testName || ''}-${category || ''}`, completeDate: completeDate, filterValue: filterValue, flaggedQns: flaggedQns, setFlaggedQns: setFlaggedQns, refetch: refetch }) }), tabId)))] }))) : ((0, jsx_runtime_1.jsx)("div", { children: "No data to show " })) })) : ((0, jsx_runtime_1.jsx)(DashboardReport_1.default, { userDiagnostic: userReport === null || userReport === void 0 ? void 0 : userReport.diagnostic, userQuestions: { questions: userReport === null || userReport === void 0 ? void 0 : userReport.questions }, handleFilter: handleFilter }))] })) })) }));
};
exports.default = UserReport;
